/**
 * @file paddle hub
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */

import request from 'superagent';
import baseRequest from '../baseApiText';


// 获取paddlehub首页数据
export const getHubStar = (): Promise<request.Response> =>
    baseRequest(
        request.get('/getGitHubStarCount')
    );